import { NavigationEnd } from "@angular/router";
import { filter, map } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/platform-browser";
export class MenuItem {
}
export class AppToolbarService {
    constructor(router, titleService) {
        this.router = router;
        this.titleService = titleService;
        this.activeMenuItem$ = this.router.events.pipe(filter(e => e instanceof NavigationEnd), map(_ => this.router.routerState.root), map(route => {
            let active = AppToolbarService.lastRouteWithMenuItem(route.root);
            this.titleService.setTitle(active.title);
            return active;
        }));
    }
    getMenuItems() {
        return this.router.config
            .filter(route => route.data && route.data.title) //only add a menu item for routes with a title set.
            .map(route => {
            return {
                path: route.path,
                title: route.data.title,
                icon: route.data.icon
            };
        });
    }
    static lastRouteWithMenuItem(route) {
        let lastMenu = undefined;
        do {
            lastMenu = AppToolbarService.extractMenu(route) || lastMenu;
        } while ((route = route.firstChild));
        return lastMenu;
    }
    static extractMenu(route) {
        let cfg = route.routeConfig;
        return cfg && cfg.data && cfg.data.title
            ? { path: cfg.path, title: cfg.data.title, icon: cfg.data.icon }
            : undefined;
    }
}
AppToolbarService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppToolbarService_Factory() { return new AppToolbarService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.Title)); }, token: AppToolbarService, providedIn: "root" });
